import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {FlashMessage} from './flash-message';
import {FlashMessagesService} from './flash-messages.service';

@Component({
    selector: 'flash-messages-anchor',
    templateUrl: './flash-messages-anchor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlashMessagesAnchorComponent implements OnDestroy {

    public flashMessages: FlashMessage[] = [];

    constructor(
        public flashMessagesService: FlashMessagesService
    ) {
        flashMessagesService.registerFlashMessagesAnchor(this);
    }

    public ngOnDestroy(): void {
        this.flashMessagesService.unregisterFlashMessagesAnchor();
    }

    public addFlashMessage(flashMessage: FlashMessage): void {
        this.flashMessages.push(flashMessage);
        flashMessage.destroy$.subscribe(
            () => {
                const iFlashMessage = this.flashMessages.indexOf(flashMessage);
                const DELETE_ONE_ITEM = 1;

                this.flashMessages.splice(iFlashMessage, DELETE_ONE_ITEM);
            }
        );
    }

}
